import { createStyles } from 'antd-style';

import {
  applyBoxShadowAfter,
  formItemSuffix,
  inputText,
  viewModeStyle,
} from '../../styles/mixins';
import {
  INPUT_BASE_HEIGHT,
  INPUT_BOX_SHADOW,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../../theme';

export const useBasicFormElementsStyles = createStyles(({ token }) => ({
  passwordWrapper: {
    '&&.ant-input-password.ant-input-affix-wrapper': {
      height: INPUT_BASE_HEIGHT,
      ...applyBoxShadowAfter(token),
      boxShadow: 'none',

      '.ant-input-suffix': {
        margin: 0,
        width: 'initial',
        ...formItemSuffix(),
      },
      '.ant-input-password-icon': {
        color: token.colorPrimary,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,

        '&.anticon::after': {
          marginLeft: ThemeSpaces.SPACE_XS,
        },
        '&.anticon-eye-invisible::after': {
          content: '"Show"',
        },
        '&.anticon-eye::after': {
          content: '"Hide"',
        },
      },
    },
  },
  formItemSuffix: {
    ...formItemSuffix(),
  },
  inputText: {
    ...inputText(token),
  },
  inputTextArea: {
    '&&': {
      minHeight: '40px !important',
      paddingTop: 10,
      boxShadow: INPUT_BOX_SHADOW,

      '&::placeholder': {
        color: ThemeColors.COLOR_GREY_BLUISH,
        fontSize: token.fontSize,
      },
    },
  },
  inputNumber: {
    '&&': {
      height: INPUT_BASE_HEIGHT,
      fontWeight: 500,
      boxShadow: INPUT_BOX_SHADOW,

      [`&.ant-input-number-status-error,
      &.ant-input-number-status-error .ant-input-number-handler-wrap,
      &.ant-input-number-status-error:focus,
      &.ant-input-number-status-error&.ant-input-number-focused,
      &.ant-input-number-status-error:hover`]: {
        backgroundColor: 'transparent',
      },
      '&::placeholder': {
        color: ThemeColors.COLOR_GREY_BLUISH,
        fontWeight: 'normal',
      },
      '&.ant-input-number-disabled, &.ant-input-number-disabled:hover, &[disabled]':
        {
          opacity: 0.5,
        },
      '&.qol-input-view-mode, &.qol-input-view-mode:hover': {
        ...viewModeStyle(ThemeColors.COLOR_GREY9_9),
      },
    },
  },
}));
